import { BlockSections } from '../../components/blocks/block-sections';
import { IContentfulImage } from '../../interfaces/contentful-image.interface';
import { gql } from '@apollo/client';
import { TextAndImageCardBlockFragment } from './textAndImageCardBlock';
import { MainBannerBlockFragment } from './mainBannerBlock';
import { SvgFragment } from './svg';

export interface IChinaPageHome {
  sys: {
    locale: string;
  };
  name: string;
  mainBannerList: BlockSections;
  cardList: {
    cards: BlockSections[];
  };
  logo: IContentfulImage;
}

export const ChinaPageHomeMinifiedFragment = gql`
  ${TextAndImageCardBlockFragment}
  ${MainBannerBlockFragment}
  ${SvgFragment}
  fragment ChinaPageHomeMinified on LibraryChinaHomePage {
    sys {
      locale
    }
    name
    cardList {
      cardsCollection {
        items {
          ... on BlockTextAndImageCard {
            ...TextAndImageCardBlock
          }
        }
      }
    }
    mainBannerList {
      ... on LibraryMeetingPlaceMainBannerList {
        blocktype: __typename
        mainBannerItemsCollection {
          items {
            ...MainBannerBlock
          }
        }
      }
    }
    logo {
      description
      # gatsbyImageData(width: 144, formats: AVIF)
      ... on Asset {
        ...Svg
      }
    }
  }
`;
